import { ChangeDetectionStrategy, Component, Injector } from '@angular/core';
import { AbstractComponent } from '@models/abstract-component';

@Component({
  selector: 'app-privacy-page',
  templateUrl: './privacy-page.component.html',
  styleUrls: ['./privacy-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyPageComponent extends AbstractComponent {
  public organizationName = 'Global-77 llc';
  public organizationEmail = 'info@viksi666.com';
  public organizationPostAddress = 'Yerevan , 13 Argishti str., Apt. 39,AM';
  public organizationHomeUrl = 'viksi666.com';

  constructor(protected inject: Injector) {
    super(inject);
  }
}
